const width = 4560
const speed = 0.5
const strength = 0.6

export default class topRecipessAnimation {
  constructor(param, scroll) {
    this.param = param;
    this.scroll = scroll;

    this.duration = 0;
    this.signedDuration = 0;

    // TODO SPのときだけdiffIncの値が巨大なのきているので、そこを直すか回避する処理をあとで入れるためにこれを使う
    this.is_sp = param.displayType === "sp";
  }

  init() {
    this.myvermicularSec = document.getElementById('p-myvermicular');
    this.myvermicularBg = document.querySelector('#p-myvermicular__bg');

    this.bgText = this.myvermicularBg.querySelectorAll('.bg-text');
    this.bgText0 = this.bgText[0]
    this.bgText1 = this.bgText[1]
    this.bgText2 = this.bgText[2]
    if (this.param.browserType !== 'IE') {
      Array.prototype.forEach.call(this.bgText, (el, i) => {
        TweenMax.set(el, { willChange: 'transform' })
      })
    }

    // images
    this.image1 = document.querySelector('.js-myvermicular-image1')
    this.image2 = document.querySelector('.js-myvermicular-image2')
    this.image3 = document.querySelector('.js-myvermicular-image3')
    // 領域にきたらアニメーション、過ぎたら止める
    const myvermicularRect = this.myvermicularSec.getBoundingClientRect()
    this.paralaxStart = (myvermicularRect.top + window.pageYOffset) - window.innerHeight * 1.3
    this.paralaxEnd =  (myvermicularRect.bottom + window.pageYOffset) + window.innerHeight * 0.2

    // 最初画像はフェードアウト
    if(!this.is_sp) {
      TweenMax.set(this.image1, { opacity: 0 })
      TweenMax.set(this.image2, { opacity: 0 })
      TweenMax.set(this.image3, { opacity: 0 })
      this.isImageShow = false
    }
  }

  render(nowInc, diffInc, signedDiffInc) {
    if (!this.bgText) return

    if(nowInc > this.paralaxStart && nowInc < this.paralaxEnd) {
      // SPのときだけ何故かdiffIncの値が巨大なのきているので、処理を分岐する
      if(this.is_sp) {
        if(!this.pastInc) this.pastInc = nowInc
        this.currentInc = nowInc

        this.signedDuration = Math.round((this.currentInc - this.pastInc) * 10 / 10)
        this.duration = Math.abs(this.signedDuration)
      } else {
        this.signedDuration = Math.round(signedDiffInc * 10) / 10
        this.duration = Math.round(diffInc * 10) / 10
      }

      // image
      if(this.duration > 0.1) {
        this.showImages()
        TweenMax.set(this.image1, { y: `-=${this.signedDuration * (this.is_sp ? 0.02 : 0.08) }` })
        TweenMax.set(this.image2, { y: `+=${this.signedDuration * (this.is_sp ? 0.05 : 0.12) }` })
        TweenMax.set(this.image3, { y: `-=${this.signedDuration * (this.is_sp ? 0.07 : 0.18) }` })
      }
      if(this.is_sp) this.pastInc = this.currentInc

      // bg
      const pos = speed + this.duration * strength

      TweenMax.set(this.bgText0, { x: `+=${pos}` })
      TweenMax.set(this.bgText1, { x: `-=${pos}` })
      TweenMax.set(this.bgText2, { x: `+=${pos}` })
      if (this.bgText0._gsTransform.x > width) {
        TweenMax.set(this.bgText0, { x: 0 })
      }
      if (-this.bgText1._gsTransform.x > width) {
        TweenMax.set(this.bgText1, { x: 0 })
      }
      if (this.bgText2._gsTransform.x > width) {
        TweenMax.set(this.bgText2, { x: 0 })
      }
    }
  }

  showImages() {
    if(!this.isImageShow) {
      this.isImageShow = true
      TweenMax.to(this.image1, 0.6, { opacity: 1, ease:Sine.easeIn, delay: 0.2 })
      TweenMax.to(this.image2, 0.6, { opacity: 1, ease:Sine.easeIn, delay: 0.1 })
      TweenMax.to(this.image3, 0.6, { opacity: 1, ease:Sine.easeIn })
    }
  }

  resize(_w, _h, _display) {
  }
}